export enum BankAccountTypeAPI {
  SAVINGS,
  CHEQUE_CURRENT,
}
